module.exports = __webpack_public_path__ + "img/credit-insurance.6590daf3.png";